export enum EWebsocket {
  WORKSTATION_AVAILABILITY = 'senet_id.booking.workstation_availability',
  ONLINE_PAYMENT = 'senet_id.online_payment',
  BILLING_INFO = 'senet_id.billing_info',
}
